class ProductComparisonTabs {
  constructor(section) {
    this.section = section;
    this.tabs = Array.from(section.querySelectorAll('[data-comparison-tab]'));
    this.panels = Array.from(section.querySelectorAll('[data-comparison-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.setActiveTab(tab.dataset.comparisonTab));
    });
  }

  setActiveTab(activeTab) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.comparisonTab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.comparisonPanel === activeTab;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

function initProductComparisonTabs(container = document) {
  container.querySelectorAll('[data-product-comparison]').forEach((section) => {
    if (section.dataset.tabsInitialized === 'true') return;

    section.dataset.tabsInitialized = 'true';
    new ProductComparisonTabs(section);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductComparisonTabs();
});

document.addEventListener('shopify:section:load', (event) => {
  initProductComparisonTabs(event.target);
});